<div class="container">
  <mat-toolbar class="items-aling">
    <span>{{ model ? 'Editar Actividad' : 'Agregar Actividad' }}</span>
  </mat-toolbar>

  <mat-card style="margin-top: 10px">
    <form [formGroup]="form" (ngSubmit)="model ? update(form.value) : agregar(form.value)" appPermissionControl="P002F0001">
      <mat-grid-list cols="4" rowHeight="70px">
        <mat-grid-tile [colspan]="1" [rowspan]="1">
          <ng-container>
            <mat-form-field class="largoFm" color="accent" appearance="outline">
              <mat-label>Campo</mat-label>
              <input matInput placeholder="123" formControlName="clavePerfil" type="text" appPermissionControl="P002K0001" />
            </mat-form-field>
          </ng-container>
        </mat-grid-tile>

        <mat-grid-tile [colspan]="1" [rowspan]="1">
          <ng-container>
            <mat-form-field class="largoFm" color="accent" appearance="outline">
              <mat-label>Variable</mat-label>
              <input matInput placeholder="Ejemplo..." formControlName="variable" type="text" appPermissionControl="P002K0002" />
            </mat-form-field>
          </ng-container>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="1" [rowspan]="1">
          <ng-container>
            <mat-form-field class="largoFm" color="accent" appearance="outline">
              <mat-label>Rango</mat-label>
              <input matInput placeholder="Ejemplo..." formControlName="rango" type="text" appPermissionControl="P002K0003" />
            </mat-form-field>
          </ng-container>
        </mat-grid-tile>

        <mat-grid-tile [colspan]="1" [rowspan]="1">
          <mat-form-field color="accent" appearance="outline">
            <mat-label>Tipo Actividad</mat-label>
            <mat-select formControlName="tipo" required (selectionChange)="onChangeSelect($event)" appPermissionControl="P002K0004">
              <mat-option *ngFor="let option of opcionesActividades" [(value)]="option.valor">
                {{ option.opcion }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile [colspan]="4" [rowspan]="1">
          <button type="submit" mat-raised-button style="margin-right: 20px" color="accent" [disabled]="form.invalid" appPermissionControl="P002B0001">
            {{ model ? 'Actualizar' : 'Guardar' }}
          </button>
          <button mat-raised-button color="accent" type="button" (click)="close()" appPermissionControl="P002B0002">Cerrar</button>
        </mat-grid-tile>
      </mat-grid-list>
    </form>
  </mat-card>
</div>
